import React from "react";
import { Container } from "react-bootstrap";
import { stringConstants } from "../../../helpers";
import LogisticPartner from "../common/LogisticPartner";
import UserDetails from "../AdminPanelBharee/UsersList/UserDetails";
import LPSettings from "./LPSettings";
import Dashboard from "./Dashboard";
import ReportsMonthlyTrips from "./ReportsMonthlyTrips";

const AdminPanelLogistic = ({
  currentView,
  notificationOrderId,
  notificationEnquiryId,
  currentViewId,
  currentViewObj,
}) => {
  switch (currentView) {
    case stringConstants.DASHBOAD:
      return <Dashboard notificationOrderId={notificationOrderId} />;
    case stringConstants.LOGISTIC_PARTNER_SETTINGS:
      return <LPSettings />;
    case stringConstants.LOGISTIC_MONTHLY_TRIP:
      return <ReportsMonthlyTrips />;
    case stringConstants.LOGISTIC_SELLER_TRIP:
      return <Container>{"Reports Seller Trip work in process.."}</Container>;
    default:
      return <Container>{"work in process.."}</Container>;
  }
};

export default AdminPanelLogistic;
